// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"7dc3a4c4","427":"9eac623d","480":"7d6bc5d0","582":"6acd3b92","711":"a10a42f7","818":"aee96830","981":"e9403ac2"}[chunkId] + ".chunk.js";
};